import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import MainLayout from './components/MainLayout';
import Dashboard from './pages/Dashboard';
import LoginPage from './pages/LoginPage';
import PeoplePage from './pages/PeoplePage';
import VideosPage from './pages/VideosPage';
import LinksPage from './pages/LinksPage';
import ReportsPage from './pages/ReportsPage';
import UsersPage from './pages/UsersPage';
import TestPage from './pages/TestPage';
import logo from './logo.svg';
import './App.css';
import './theme.css';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFC107',
      light: '#FFEB3B',
      dark: '#880E4F',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#F50057',
      light: '#FFC947',
      dark: '#535A70',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#121212',
      paper: '#1E1E1E',
    },
    text: {
      primary: '#FFFFFF',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

const ProtectedRoute = ({ children }: { children: React.ReactElement }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Yükleniyor...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <MainLayout>
                  <Dashboard />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/people" element={
              <ProtectedRoute>
                <MainLayout>
                  <PeoplePage />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/videos" element={
              <ProtectedRoute>
                <MainLayout>
                  <VideosPage />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/links" element={
              <ProtectedRoute>
                <MainLayout>
                  <LinksPage />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/reports" element={
              <ProtectedRoute>
                <MainLayout>
                  <ReportsPage />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute>
                <MainLayout>
                  <UsersPage />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/test" element={<TestPage />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
